import axios from 'axios';
import { API } from '../../utils/api';
import { DOCUMENT_SERVICE_PROVIDER_CODE, ACCESS_TOKEN } from '../../utils/constants';
import authUtil from '../../utils/AuthUtils';

/**
 * Fetches user information from the API based on the provided company reference.
 * 
 * @param {string} company_ref - The reference code for the company.
 * @returns {Promise<Object>} Promise resolving to the user information data.
 * @throws {Error} If there is an error fetching user information.
 */

function getWorkspaces(company_ref) {
  let AUTH_TOKEN = localStorage.getItem(ACCESS_TOKEN);
  if(!AUTH_TOKEN) {
    authUtil.clearSession();
    window.location.href = `${window.location.origin}/login`;
  }
  return axios
    .get(API.USER.getUserInfo, {
      headers: {
        Authorization: `Bearer ${AUTH_TOKEN}`,
        'X-SERVICE-PROVIDER-CODE': DOCUMENT_SERVICE_PROVIDER_CODE,
        'X-COMPANY-REFERENCE': company_ref
      },
    })
    .then((res) => {
      const userData = res?.data;
      
      // Extract the clientTypeCode from serviceProviderDetails where 
      // serviceProviderCode matches DOCUMENT_SERVICE_PROVIDER_CODE
      let clientTypeCode = '';
      
      if (userData.serviceProviderDetails && Array.isArray(userData.serviceProviderDetails)) {
        const matchingProvider = userData.serviceProviderDetails.find(
          provider => provider.serviceProviderCode === DOCUMENT_SERVICE_PROVIDER_CODE
        );
        
        if (matchingProvider) {
          clientTypeCode = matchingProvider.clientTypeCode;
        }
      }
      
      // Return the userData with the extracted clientTypeCode
      return {
        ...userData,
        clientTypeCode
      };
    })
    .catch((error) => {
      console.error('Error fetching workspaces:', error);
      authUtil.clearSession();
      throw error;
    });
}

export default getWorkspaces;
